export const localStorageKeys = {
  INTENT_ID_OF_VERIFICATION: 'intentIdOfVerification',
  ENABLE_PAYMENT_REQUEST: 'enablePaymentRequestApi',
  AWX_LANG: 'awx_lang',
};

export const deviceOSMapping: { [key: string]: 'ios' | 'android' } = {
  iOS: 'ios',
  'Android OS': 'android',
};
